// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';
import Dropdown from 'stimulus-dropdown';
import Reveal from 'stimulus-reveal-controller';
import TurboController from './turbo_controller';
import SearchCard from './search_card_controller';
import ProfileController from './profile_controller';
import PositionController from './position_controller';
import SearchNewsEvents from './search_news_events_controller';
import PreviewController from './admin/preview_controller';
import Clipboard from 'stimulus-clipboard';
import SetDateTime from './admin/date_time_controller';
import TurboModalController from './turbo_modal_controller';
import FlashMessagesController from './flash_messages_controller';
import DormancyModalMessageController from './dormancy_modal_message_controller';
import MenuController from './menu_controller';
import ScrollController from './scroll_controller';
import FooterController from './footer_controller';
import ModalController from './modal_controller';
import ArticleFormController from './admin/article_form_controller';
import ToggleProfileFieldsController from './toggle_profile_fields_controller';

application.register('dropdown', Dropdown);
application.register('reveal', Reveal);
application.register('turbo', TurboController);
application.register('search', SearchCard);
application.register('profile', ProfileController);
application.register('position', PositionController);
application.register('searchNewsEvents', SearchNewsEvents);
application.register('preview', PreviewController);
application.register('setNewsEvents', SetDateTime);
application.register('clipboard', Clipboard);
application.register('turbo-modal', TurboModalController);
application.register('flash-messages', FlashMessagesController);
application.register('dormancy-modal-message', DormancyModalMessageController);
application.register('menu', MenuController);
application.register('scroll', ScrollController);
application.register('footer', FooterController);
application.register('modal', ModalController);
application.register('article-form', ArticleFormController);
application.register('toggle-profile-fields', ToggleProfileFieldsController);
